<template>
  <div class="contents-box">
      <div class="contents">
          <p class="contents-title">感谢您注册MOVIBOT！</p>
          <p class="contents-info">还需一步即可完成注册，我们已将确认邮件发送至您的邮箱 {{UserMail}}</p>
          <p class="contents-info">请进入邮箱完成激活流程，点击邮件里的确认链接。</p>
          <!--<p  class="tomail"><router-link :to="{ path: 'home' }">登录邮箱</router-link></p>-->
          <div class="contents-help">
              <p class="contents-help-title">未收到电子邮件？</p>
              <p class="contents-help-info">尝试到广告邮件、垃圾邮件目录里找找看，或者点击 <span  @click="sendMail">再次发送</span></p>
          </div>
          <p class="contents-lable">
              如有任何问题请联系客服 public@tjchenxing.com或拨打电话 400-653-7789或155-2241-5492我们会在1日内答复
          </p>
      </div>
  </div>
</template>

<script>
import { Message  } from 'element-ui';
import { mapGetters } from 'vuex';
export default {    
    methods:{        
        sendMail(){
            this.$api.user.sendMail().then(res=>{
                if(res.data.errno==0){
                   this.$FUnitls.showInfo("发送成功",'success') 
                }else{
                    var options={
                        message:res.data.errmsg,
                    }
                    Message.error(options)
                }
               
            });
        }
    },
    computed:{
        ...mapGetters(['UserMail'])
    },
}
</script>

<style scoped>
    .contents-box{
        background-color: #F3F5F7;
        overflow: hidden;
        min-height: 900px;
    }
    .contents-title{
        font-size: 32px;
        line-height: 35px;
        color: #2655AE;
        margin-top: 38px;
        margin-bottom: 30px;
    }
    .contents-info{
        font-size: 20px;
        line-height: 25px;
        color: #666666;
        
    }
    .contents-info:last-child{
        margin-bottom: 33px;
    }
    .contents .tomail a{
        font-size: 20px;
        line-height: 22px;
        text-decoration-line: underline;
        color: #2655AE;
        
    }
    .contents .tomail{
        margin-top: 33px;
    }
    
    .contents .contents-help{
        width: 100%;
        background-color: #fff;
        border-radius: 10px;
        padding: 22px;
        margin-top: 44px;
        margin-bottom: 19px;
    }
    .contents .contents-help-title{
        font-size: 24px;
        line-height: 26px;
        color: #666666;
        margin-bottom: 10px;
    }
    .contents .contents-lable{
        font-size: 20px;
        line-height: 22px;
        color: #999999;
    }
     .contents-help-info{
        font-size: 20px;
        line-height: 22px;
         color: #333;
     }
    .contents-help-info span{
        cursor:pointer;
        color: #2655AE;
    }

</style>


// WEBPACK FOOTER //
// src/views/user/toactivate.vue